import { useContext } from "react";
import { SurveyResultMapInfoContext } from "../contexts/SurveyResultMapInfoContext";

function useMapInfo() {
    return useContext(SurveyResultMapInfoContext);
}

export default useMapInfo